import React from 'react'

import { TagProps } from './Tag.types'

import './Tag.scss'

const Tag: React.FC<TagProps> = ({
  style,
  children 
}) => {
  
  return (
    <code
      style={{
        width:'fit-content',
        display: 'flex',
        alignItems: 'center',
        padding: '0px 6px',
        border: '1px solid var(--primary)',
        borderRadius: 4,
        color: 'var(--primary)',
        background: 'var(--primary0)',
        textDecoration: 'none',
        fontVariantNumeric: 'tabular-nums',
        ...style
      }}
    >
      {children}
    </code>
  )
}

export default Tag  

